import * as React from "react";
import { createContext, useContext } from "react";
// @ts-ignore
import bootstrapStyles from "../lazy-loading/BootstrapCSS.lazy.scss";

interface BootstrapContextType {
	enableBootstrap: () => void;
	disableBootstrap: () => void;
}

let usageCount = 0;

const globalEnableBootstrap = () => {
	usageCount++;
	if (usageCount === 1) {
		bootstrapStyles.use();
	}
};

const globalDisableBootstrap = () => {
	if (usageCount <= 0) {
		return;
	}
	bootstrapStyles.unuse();
	usageCount = 0;
};

const noOpContext: BootstrapContextType = {
	enableBootstrap: globalEnableBootstrap,
	disableBootstrap: globalDisableBootstrap,
};

const BootstrapContext = createContext<BootstrapContextType | undefined>(undefined);

export function BootstrapProvider({ children }: { children: React.ReactNode }) {
	return <BootstrapContext.Provider value={noOpContext}>{children}</BootstrapContext.Provider>;
}

export function useBootstrap(): BootstrapContextType {
	const context = useContext(BootstrapContext);
	// If context is undefined, fall back to the global implementation.
	// This handles cases with multiple React versions.
	if (!context) {
		return noOpContext;
	}
	return context;
}
